// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  jobId: __t.u64().primaryKey().name("job_id"),
  projectId: __t.u64().name("project_id"),
  status: __t.string(),
  buildId: __t.u64().name("build_id"),
  diagnostics: __t.string(),
  startedAt: __t.timestamp().name("started_at"),
  finishedAt: __t.timestamp().name("finished_at"),
});
